import { useStore } from 'zustand'
import { devtools } from 'zustand/middleware'
import { createStore } from 'zustand/vanilla'

import { AppStore } from './AppStoreTypes'
import createDedupedStoreFromSlices from './createDedupedStoreFromSlices'
import createNotificationCosmicSlice from './notification-cosmic/createNotificationSlice'

/**
 * The vanillaStore can be accessed directly via imports without
 * the use of the `useStore` React hook.
 *
 * https://github.com/pmndrs/zustand#using-zustand-without-react
 */
export const vanillaStore = createStore<AppStore>()(
  devtools((...a) => createDedupedStoreFromSlices([createNotificationCosmicSlice(...a)]))
)

/**
 * The hook to access global state values and their setters across the dashboard.
 * The state setup adheres to the slices pattern described in the [Zustand docs](https://github.com/pmndrs/zustand/blob/main/docs/guides/typescript.md#slices-pattern),
 * with the exception of our own helper that validates the uniqueness of state keys.
 */
const useAppStore = <T>(selector: (state: AppStore) => T) => useStore(vanillaStore, selector)

export default useAppStore
